<template>
  <div>
    <breadcrumb-one
      banner_height="page-banner-height-2"
      :banner="content.contact_banner_image_url || ''"
      :title="content.contact_banner_title || 'Contact Us'"
      :subtitle="content.contact_banner_subtitle || 'Contact Us'"
    ></breadcrumb-one>

    <div class="location-area pt-70 pb-25">
      <div class="container">
        <div class="row mb-25">
          <div class="col-xl-12">
            <div class="abs-section-title text-center">
              <span>LOCATION STORE</span>
              <h4>Where We Are</h4>
              <p>
                The perfect way to enjoy brewing tea on low hanging fruit to
                identify. Duis autem vel eum iriure dolor in hendrerit <br />
                in vulputate velit esse molestie consequat, vel illum dolore eu
                feugiat nulla facilisis.
              </p>
            </div>
          </div>
        </div>

        <div class="row" v-if="locations.length > 0">
          <div
            v-for="location in locations"
            :key="location.id"
            class="col-xl-3 col-lg-3 col-md-6"
          >
            <div class="location-item mb-30">
              <div class="location-image w-img mb-20">
                <img
                  :src="location.location_image_url || '/images/location/location-1.jpg'"
                  alt="image"
                />
              </div>
              <h6>{{ location.location_title }}</h6>

              <div
                v-if="location.address"
                class="sm-item-loc sm-item-border mb-20"
              >
                <div class="sml-icon mr-20">
                  <i class="fal fa-map-marker-alt"></i>
                </div>
                <div class="sm-content">
                  <span>Find us</span>
                  <p>{{ location.address }}</p>
                </div>
              </div>

              <div
                v-if="location.phone"
                class="sm-item-loc sm-item-border mb-20"
              >
                <div class="sml-icon mr-20">
                  <i class="fal fa-phone-alt"></i>
                </div>
                <div class="sm-content">
                  <span>Call us</span>
                  <p>
                    <a :href="`tel:${location.phone}`">{{ location.phone }}</a>
                  </p>
                </div>
              </div>

              <div v-if="location.email" class="sm-item-loc mb-20">
                <div class="sml-icon mr-20">
                  <i class="fal fa-envelope"></i>
                </div>
                <div class="sm-content">
                  <span>Mail us</span>
                  <p>
                    <a :href="`mailto:${location.email}`">{{ location.email }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-xl-12 text-center py-4 text-muted">
            <p>No locations available.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="cmamps-area" v-if="mapUrl">
      <iframe :src="mapUrl"></iframe>
    </div>
  </div>
</template>

<script>
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Contact",
  components: {
    BreadcrumbOne,
  },
  data() {
    return {
      content: {},
      locations: [],
    }
  },
  computed: {
    mapUrl() {
      return this.content.google_map_embed_url || ''
    },
  },
  mounted() {
    this.fetchContent()
  },
  methods: {
    async fetchContent() {
      try {
        const { data } = await this.$axios.get('/cms/contact')
        this.content   = data.content   || {}
        // only show active locations on the public site
        const all = data.locations || []
        this.locations = all.filter(l => l.is_active === undefined || l.is_active)
      } catch (err) {
        console.error('Failed to load contact page content:', err)
      }
    },
  },
}
</script>

<style scoped>
/* Add styles for Home page */
</style>